export default __webpack_public_path__ + "static/media/Account-Symbol.b5f41b28.svg";